import React from 'react';
import Icon, { Props as IconProps } from './icon';

interface Props extends IconProps {
  open?: boolean;
}

export const PlayCircleIcon: React.FC<Props> = (props: Props) => {
  const { open = true } = props;
  return (
    open && (
      <Icon {...props}>
        <path d="m12,4c-4.42,0-8,3.58-8,8s3.58,8,8,8,8-3.58,8-8-3.58-8-8-8ZM2,12C2,6.48,6.48,2,12,2s10,4.48,10,10-4.48,10-10,10S2,17.52,2,12Zm10-1c.55,0,1,.45,1,1v5c0,.55-.45,1-1,1s-1-.45-1-1v-5c0-.55.45-1,1-1Zm0-1.5c.69,0,1.25-.56,1.25-1.25s-.56-1.25-1.25-1.25-1.25.56-1.25,1.25.56,1.25,1.25,1.25Z" />
      </Icon>
    )
  );
};

export default React.memo(PlayCircleIcon);
